import React from 'react';
import styled from 'styled-components';
import { FaTimes } from 'react-icons/fa'; // Import close icon

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000; // Ensure it's on top
`;

const ModalContent = styled.div`
    // ... existing styles
    background-color: #fff;
    padding: 30px 40px;
    border-radius: 8px;
    position: relative;
    min-width: 250px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    /* Add class name */
    &.modal-content-class {}
`;

const CloseButton = styled.button`
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #555;
    padding: 5px;
    line-height: 1;

    &:hover {
        color: #000;
    }
`;

const SettingRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px; // Increased margin slightly
    min-height: 30px; // Ensure consistent height

    label {
        margin-right: 15px; // Adjusted margin
        color: #333;
        white-space: nowrap; // Prevent label wrapping
    }

    input[type="checkbox"] {
        transform: scale(1.2);
        cursor: pointer;
    }

    input[type="range"] {
        flex-grow: 1; // Allow slider to take available space
        cursor: pointer;
        margin: 0 10px; // Add some horizontal margin
    }

    .sensitivity-value {
        min-width: 40px; // Reserve space for the number
        text-align: right;
        font-family: monospace; // Use monospace for consistent number width
        color: #555;
    }
`;

const Title = styled.h2`
    margin-top: 0;
    margin-bottom: 25px;
    color: #333;
    text-align: center;
`;

const SettingsModal = ({
                           isOpen,
                           onClose,
                           invertY,
                           onInvertYChange,
                           lookSensitivity, // New prop
                           onSensitivityChange, // New prop
                           playerName, // NEW: player name value
                           onPlayerNameChange, // NEW: handler
}) => {
    if (!isOpen) {
        return null;
    }

    const handleCheckboxChange = (event) => {
        onInvertYChange(event.target.checked);
    };

    // Handler for the sensitivity slider
    const handleSliderChange = (event) => {
        // Input range value is a string, convert to float
        onSensitivityChange(parseFloat(event.target.value));
    };

    const handleNameInputChange = (e) => {
        onPlayerNameChange(e.target.value);
    };

    return (
        <ModalOverlay onClick={onClose}> {/* Close on overlay click */}
            <ModalContent className="modal-content-class" onClick={(e) => e.stopPropagation()}> {/* Prevent closing when clicking inside content */}
                <CloseButton onClick={onClose} aria-label="Close settings">
                    <FaTimes />
                </CloseButton>
                <Title>Settings</Title>

                {/* Player Display Name */}
                <SettingRow>
                    <label htmlFor="playerNameInput">Player Name</label>
                    <input
                        type="text"
                        id="playerNameInput"
                        placeholder="Enter your name"
                        maxLength={40}
                        value={playerName || ''}
                        onChange={handleNameInputChange}
                        style={{ flexGrow: 1 }}
                    />
                </SettingRow>

                {/* Invert Y Setting */}
                <SettingRow>
                    <label htmlFor="invertYCheckbox">Invert Mouse Y-Axis</label>
                    <input
                        type="checkbox"
                        id="invertYCheckbox"
                        checked={invertY}
                        onChange={handleCheckboxChange}
                    />
                </SettingRow>

                {/* Look Sensitivity Setting */}
                <SettingRow>
                    <label htmlFor="sensitivitySlider">Look Sensitivity</label>
                    <input
                        type="range"
                        id="sensitivitySlider"
                        min="0.001" // Minimum sensitivity
                        max="0.015" // Maximum sensitivity (adjust as needed)
                        step="0.0005" // Step increment
                        value={lookSensitivity}
                        onChange={handleSliderChange}
                    />
                    {/* Display the current value */}
                    <span className="sensitivity-value">
                        {lookSensitivity.toFixed(4)}
                    </span>
                </SettingRow>
                {/* Add more settings here in the future */}
            </ModalContent>
        </ModalOverlay>
    );
};

export default SettingsModal;
